export const Constants = {
  resetPassword: 'Alterar Senha',
  newPassword: 'Nova Senha',
  confirm: 'confirmar',
  confirmHelp: 'as senhas devem ser iguais',
  confirmPassword: 'confirme a nova senha',
  password: 'digite a nova senha',
  passwordHelp:
    'mínimo de 8 caracteres com letra mínuscula, maiúscula e número',
};
